import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-notification-bar',
    templateUrl: './notification-bar.component.html',
    styleUrls: ['./notification-bar.component.scss'],
})
export class NotificationBarComponent
{
    @Input() isAdmin = false;
    @Input() status: 'warning' | 'info';

    @Input() headerText = '';
    @Input() messageText = '';
    @Input() actionText = '';

    @Output() onAction: EventEmitter<void> = new EventEmitter<void>();
}
